import qs from 'qs';
import request from '../utils/request';

// 添加公司
export const creatComapny = (data) => request({
  url: '/admin/company',
  method: 'post',
  data,
});
// 公司列表
export const companyList = (param) => request(`/admin/company?${qs.stringify(param)}`);
// 公司详情
export const companyDetail = (id) => request(`/admin/company/${id}`);
// 公司修改
export const companyModify = (id, data) => request({
  url: `/admin/company/${id}`,
  method: 'put',
  data,
});
// 公司搜索
export const companySearch = (name, limit) => request(`/admin/company/search/search-with-name?name=${name}&limit=${limit}`);
// 获取微信菜单信息
export const mpMenu = (companyId) => request(`/admin/mp-menu/${companyId}`);
// 设置微信菜单
export const setMenu = (id, data) => request({
  url: `/admin/set-mp-menu/${id}`,
  method: 'put',
  data,
});
// 获取充值配置
export const getComapnyRechargeQrcode = (id, balance) => request(`/admin/companyconsume/recharge-config/${id}/${balance}`);
// 获取支付详情
export const getComapnyRechargeDetail = (id) => request(`/admin/companyconsume/${id}`);
// 获取公司充值及扣费记录
export const companyconsume = (param) => request(`/admin/companyconsume?${qs.stringify(param)}`);
// 公司日报
export const companydailyreport = (param) => request(`/admin/company/company-daily-report?${qs.stringify(param)}`);
// 提现
export const createcompanywithdrawal = (data) => request({
  url: '/admin/company/withdrawal',
  method: 'post',
  data,
});
// 提现
export const getcompanywithdrawal = (param) => request(`/admin/company/withdrawal?${qs.stringify(param)}`);
// 提现审核
export const withdrawalAudit = (id, status) => request({
  url: `/admin/company/withdrawal/audit/${id}/${status}`,
  method: 'put',
});
// 确认提现
export const withdrawalConfirm = (id) => request({
  url: `/admin/company/withdrawal/confirm/${id}`,
  method: 'put',
});
